import React from 'react';
import InputWrapper from '../Wrappers/InputWrapper';
import withFormValidations from 'react-validator';
import { store } from '../../store';
import * as actions from '../../actions/auth';

const reduxForValidator = {
  store: store,
  actions
}

class Login extends React.Component {
  state = {
    success: false,
    showPassword: false,
    forgot: false,
    confirmForgot: false
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ forgot: nextProps.auth.get('user').get('auto_generated') });
  }

  componentDidMount() {
    document.addEventListener('keypress', this._handleKeyPress);
    this.setFocus('email');
  }

  componentWillUnmount() {
    document.removeEventListener('keypress', this._handleKeyPress);
  }

  setFocus = type => {
    const inputs = document.getElementsByTagName('input');
    for(var i = 0; i <= inputs.length; i++) {
      if (inputs[i] && inputs[i].type === type) {
        inputs[i].focus();
      }
    }
  }

  onChange = (input, value) => {
    if (input.label === 'email') this.props.updateEmail(value);
    this.props.onChange(input, value);
  }

  _handleKeyPress = event => {
    if (event.keyCode === 13) {
      this._submit();
    }
  }

  _submit = (skipValidations, e) => {
    const { auth, field } = this.props;

    if (this.state.forgot && field('email').validations.errors.length < 1) {
      return this.props._auth.forgot(this.props.inputs)
        .then(res => this.setState({
          forgot: false,
          confirmForgot: true
        }));
    }

    if (field('email').validations.errors.length < 1) {
      this.setState({ showPassword: true, success: false });
      // this is not ideal, but until react-validator returns a promise, it has to do
      field('email').validations._reduxRules.find(r => r.rule === 'validateEmail').promise
        .then(res => {
          this.props.registeredUser(auth.get('validations').get('validEmail'));
          res.data.length > 0 && this.setFocus('password');
        });
    }

    if (!skipValidations && this.props.valid()) {
      this.props._auth.logIn(this.props.inputs)
        .then(res => !res.error && this.props._auth.toggleAuthenticationModal())
    }
  }

  _silentValidation = (event, elem, input = false) => {
    this.props.valid(elem);
    if (elem.validations.errors.length < 1) this.setState({ success: true });
    elem.validations.reset();
  }

  _toggleForgot = event => {
    this.setState({ forgot: !this.state.forgot });
  }

  render() {
    const { auth, field } = this.props;
    const email = field('email');
    const password = field('password');

    return <div>
        <h3>So good to see you.</h3>
        {this.props.merchant.get('invite_code') && <p>
          You've been invited to join Localvore!<br/> Get started below:
        </p>}

        <p className="fine-print">
          Let's eat, drink, be local! <span className="required">All fields required, please.</span>
        </p>
        {!this.state.confirmForgot && <div>
          <div className="form-group">
            <label htmlFor="email">Your email</label>
            {email &&
              <InputWrapper {...this.props}
                input={email}
                onKeyDown={this._silentValidation.bind(this, null, email)}
                onChange={this.onChange}
                onBlur={!this.state.forgot && this._submit.bind(this, true)}
                valid={this.props.valid}
                type="email" />}
          </div>

          {this.state.showPassword &&
            !this.state.forgot &&
            <div className="form-group">
              <label htmlFor="password">Password</label>
              {password &&
                <InputWrapper {...this.props}
                  input={password}
                  onKeyDown={this._silentValidation.bind(this, null, password)}
                  onChange={this.onChange}
                  valid={this.props.valid}
                  type="password" />}

                <div className="forgot"><a onMouseDown={this._toggleForgot}>Forgot password?</a></div>
          </div>}

          {auth.get('errors').size > 0 && <ul style={{ marginBottom: '20px' }}>
            {auth.get('errors').map((e, i) => <li key={i} className="error">
              <i className="fa fa-exclamation-circle"></i>
              {e.get('detail')}
            </li>)}
          </ul>}

          <div className="form-action">
            {this.state.forgot && 
              <div className="row">
                <div className="col-md-6">
                  <button type="button" onClick={this._toggleForgot}>Cancel</button>
                </div>
                <div className="col-md-6">
                  <button type="button" className="valid" onClick={this._submit.bind(this, false)}>Send magic link <i className="fa fa-angle-right"></i></button>
                </div>
              </div>}

            {auth.get('loading') && 
                <button className="valid">Loading <i className="fa fa-circle-o-notch slow-spin" aria-hidden="true"></i></button>}

            {!this.state.forgot &&
             !auth.get('loading') &&
              <button type="button" 
                className={this.state.success && 'valid'}
                onClick={this._submit.bind(this, false)}>Save and Continue <i className="fa fa-angle-right"></i></button>}
          </div>
        </div>}

        {this.state.confirmForgot && <div>
          <h5>Check your email!</h5>
          <p>An email has been sent to the address provided with a link that will automatically log you into your account.</p>
        </div>}
      </div>;
  }
}

export default withFormValidations(Login, [{
    label: 'email',
    rules: [{
      rule: 'email',
      message: 'Invalid email address'
    }, {
      rule: 'required',
      message: 'An email address is required'
    }, {
      rule: 'validateEmail',
      message: ''
    }]
  }, {
    label: 'password',
    rules: [{
      rule: 'required',
      message: 'A password is required'
    }]
  }], reduxForValidator);



// WEBPACK FOOTER //
// ./src/components/User/Login.js